export default __webpack_public_path__ + "static/media/gallery39.7cec14e8.jpg";